import React from 'react';
import { observer } from 'mobx-react';
import { KYC_REQUIRED_MODAL_ID } from 'common/constants/profile.constants';
import { kycStore } from 'common/stores/kyc.store';
import { kycService } from 'common/services/kyc.service';
import { runInAction } from 'mobx';
import { NewModal } from '../../index';
import Image from '../common.image.png';
import { S } from '../common.style';

export const RequiredKycModal = observer(() => {
  return (
    <NewModal
      ModalId={KYC_REQUIRED_MODAL_ID}
      onClose={() =>
        runInAction(() => {
          kycStore.handling403FromKycService = false;
        })
      }
    >
      <img draggable={false} src={Image} alt="KYC" width="235" height="218" />
      {kycStore.rejected || kycStore.handling403FromKycService ? (
        <>
          <S.Bold> This functionality is disabled</S.Bold>
          <S.Dimmer>Please contact customer support</S.Dimmer>
        </>
      ) : (
        <>
          <S.Bold>This functionality </S.Bold>
          <S.Dimmer>
            will be available only after passing KYC procedure
          </S.Dimmer>
        </>
      )}
      {kycStore.processing && (
        <S.Blue>Your documents are being processed</S.Blue>
      )}
      {((kycStore.needsInfo && !kycStore.handling403FromKycService) ||
        (kycStore.handling403FromPaymentService && !kycStore.rejected)) && (
        <S.Button onClick={kycService.beginForcedKyc}>Start</S.Button>
      )}
    </NewModal>
  );
});
